import useStyles from "./styles";
import {
  Avatar,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery
} from "@material-ui/core";
import React, { useContext, useState } from "react";
import CheckIcon from "@material-ui/icons/Check";
import { UserContext } from "../../../../UserProvider";
import { Authenticated } from "../../../../models/User";
import { HourglassTop } from "@mui/icons-material";
import { TenantStatus } from "../../../../models/Tenant";
import * as tenantApi from "../../../../api/tenantApi";
import { Alert } from "@material-ui/lab";
import { useTheme } from "@material-ui/core/styles";
import { useI18n } from "../../../../hooks/useI18n";

export interface FinishProps {
  onClick: () => void;
}

export const Finish = ({ onClick }: FinishProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("xs"));
  const { t } = useI18n();

  const user = useContext(UserContext) as Authenticated;

  const reviewedAndReady =
    user.tenant.status === TenantStatus.OnBoardReviewAndConfigComplete;

  const [loading, setLoading] = useState(false);

  const finish = async () => {
    setLoading(true);
    await tenantApi.updateTenantStatus(TenantStatus.Active);
    onClick();
  };

  return (
    <>
      {reviewedAndReady ? (
        <Avatar className={classes.finishedAvatar}>
          <CheckIcon className={classes.onBoardingIcon} />
        </Avatar>
      ) : (
        <Avatar className={classes.bigAvatar}>
          <HourglassTop className={classes.onBoardingIcon} />
        </Avatar>
      )}
      <Typography variant={"h4"}>
        {reviewedAndReady
          ? t("common.messages.finished")
          : t("common.messages.almostDone")}
      </Typography>
      <Typography
        className={classes.onBoardingTitle}
        variant={"subtitle1"}
        style={{ textAlign: "center", width: "70%" }}
      >
        {reviewedAndReady
          ? "Everything is ready and you can now start selling"
          : "All your steps are completed and the information is submitted for review. We will now configure your store and notify you when you are ready to start selling."}
      </Typography>
      <List>
        <ListItem>
          <ListItemIcon>
            <Avatar className={classes.stepDoneColor}>
              <CheckIcon />
            </Avatar>
          </ListItemIcon>
          <ListItemText
            primary={"Update your company information"}
            secondary={"Organizational number, bank details etc."}
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            <Avatar className={classes.stepDoneColor}>
              <CheckIcon />
            </Avatar>
          </ListItemIcon>
          <ListItemText
            primary={"Update your store details"}
            secondary={"Street, postal code, city etc."}
          />
        </ListItem>
        <ListItem>
          <ListItemIcon>
            {reviewedAndReady ? (
              <Avatar className={classes.stepDoneColor}>
                <CheckIcon />
              </Avatar>
            ) : (
              <Avatar className={classes.stepActiveColor}>
                <HourglassTop />
              </Avatar>
            )}
          </ListItemIcon>
          <ListItemText
            primary={"Review and configuration"}
            secondary={"We are now reviewing and configuring your store"}
          />
        </ListItem>
        {/*        <ListItem>
          <ListItemIcon>
            <Avatar className={classes.stepDoneColor}>
              <InfoIcon />
            </Avatar>
          </ListItemIcon>
          <ListItemText
            primary={"Upload your products"}
            secondary={
              "Upload an excel file with your products to start selling"
            }
          />
        </ListItem>*/}
      </List>
      {!reviewedAndReady && (
        <Alert
          style={{ marginBottom: 60, width: mobile ? "100%" : "50%" }}
          severity={"info"}
        >
          When we have reviewed your information, sales will contact you to
          upload your products into your store
        </Alert>
      )}
      {reviewedAndReady && (
        <Button
          className={classes.onBoardingButton}
          variant="contained"
          color="primary"
          onClick={finish}
          disabled={loading}
        >
          Close
        </Button>
      )}
    </>
  );
};
